import script from "./NhapXuatTonKhoTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./NhapXuatTonKhoTable.vue?vue&type=script&lang=ts&setup=true"

import "./NhapXuatTonKhoTable.vue?vue&type=style&index=0&id=4f16df7e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f16df7e"]])

export default __exports__